// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1CvA5","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3mchV"};